import AppPaths from '@globals/paths'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import { T } from '@transifex/react'
import { NavItem } from '../types'

export const userNavConfig: NavItem[] = [
  {
    type: 'link',
    name: <T _str="My tenants" />,
    path: AppPaths.user.tenants(),
    icon: <DashboardOutlinedIcon />,
    key: 'tenants',
  },
]
